export default __webpack_public_path__ + "static/media/mic-digital-fill.bda972c6.svg";